// extracted by mini-css-extract-plugin
export default {"translatePopoverContainer":"translatePopoverContainer_Y0RL7","translatePopoverContent":"translatePopoverContent_OhuYR"};